import { configureStore } from "@reduxjs/toolkit";
import mainSlice from "./slices/main-slice";
import configSlice from "./slices/config-slice";
import policyEditorSlice from "./slices/policy-editor-slice";
import alertReducer from "./slices/alert-slice";
import customPagesSlice from "./slices/custom-page-slice";
import intuneSlice from "./slices/intune-slice";

const store = configureStore({
  reducer: {
    main: mainSlice.reducer,
    config: configSlice.reducer,
    policyEditor: policyEditorSlice.reducer,
    alerts: alertReducer.reducer,
    customPages: customPagesSlice.reducer,
    intune: intuneSlice.reducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;